import { GetAffiliateDetailsResponse } from '../CRM/Responses/AffiliateResponse';

import Model from './Model';

export default class Affiliate extends Model {
    readonly id: number;
    readonly name: string | null = null;
    readonly token: string;
    readonly admin_id: number | null;
    readonly register_count: number = 0;
    readonly sub_register_count: number = 0;
    readonly aff_link: string | undefined;
    readonly qr_codes: undefined | { [key: string]: string };
    readonly purchase_sum: string | undefined;
    readonly deposit_sum: string | undefined;
    readonly admin_name: string | undefined;
    readonly admin_revenue: string | undefined;
    readonly unique_click_count: number = 0;
    readonly aff_percent_revenue: number;
    readonly ggr_aff_percent_revenue: number;
    readonly casino_aff_percent_revenue: number;

    constructor(affiliate: Partial<GetAffiliateDetailsResponse>) {
        super();
        this.assignDataToProps(affiliate, [
            'id',
            'name',
            'token',
            'admin_id',
            'register_count',
            'sub_register_count',
            'aff_link',
            'qr_codes',
            'purchase_sum',
            'deposit_sum',
            'admin_name',
            'admin_revenue',
            'unique_click_count',
            'aff_percent_revenue',
            'ggr_aff_percent_revenue',
            'casino_aff_percent_revenue',
        ]);
    }

    get affLink(): string {
        return this.aff_link ?? '';
    }

    get qrCodes(): { [key: string]: string } {
        return this.qr_codes ?? {};
    }

    get registerCount(): number {
        return this.register_count;
    }

    get subRegisterCount(): number {
        return this.sub_register_count;
    }

    get depositSum(): string {
        return this.deposit_sum;
    }

    get purchaseSum(): string {
        return this.purchase_sum;
    }

    get adminId(): number {
        return this.admin_id;
    }

    get adminName(): string {
        return this.admin_name;
    }

    get adminRevenue(): string {
        return this.admin_revenue;
    }

    get uniqueClickCount(): number {
        return this.unique_click_count;
    }

    public hasRegistrations(): boolean {
        return this.registerCount > 0 || this.subRegisterCount > 0;
    }

    public doesntHaveRegistrations(): boolean {
        return !this.hasRegistrations();
    }

    public hasAdmin(): boolean {
        return this.admin_id !== null;
    }

    public doesntHaveAdmin(): boolean {
        return !this.hasAdmin();
    }
}
